export const STORE_KEY = '$_question_preview';

export const TYPE_RADIO = 'radio';
export const TYPE_CHECKBOX = 'checkbox';
export const TYPE_TRUE_FALSE_NO = 'answer_t_f_no';
export const TYPE_MATH_COL = 'math_col';
export const TYPE_FILL_BLANK = 'fill_blank';
export const TYPE_FILL_SENTENCE = 'fill_sentence';
export const TYPE_SELECT = 'select';
export const TYPE_DOWN_ANSWER = 'down_answer';
export const TYPE_CIRCLE_ANSWER = 'circle_answer';
export const TYPE_X_MARK = 'x_mark_answer';
export const TYPE_DRAW_SHAPE_ANSWER = 'draw_shape_answer';
export const TYPE_GROUP = 'group';
export const TYPE_FILL_INPUT_IMG = 'fill_input_img';

export const SET_QUESTIONS = 'SET_QUESTIONS';
export const SET_QUESTION = 'SET_QUESTION';
export const VALIDATE_QUESTION = 'VALIDATE_QUESTION';
export const SET_QUESTION_SCROLL = 'SET_QUESTION_SCROLL';
export const SET_CORRECT_GROUP_VALUE = 'SET_CORRECT_GROUP_VALUE';
export const SET_VIEW_APPROVAL_ITEM = 'SET_VIEW_APPROVAL_ITEM';
export const SET_QUESTION_GROUP = 'SET_QUESTION_GROUP';
export const SET_CHANGE_ANSWER = 'SET_CHANGE_ANSWER';
export const SET_ANSWER_WRITED_EBOOK = 'SET_ANSWER_WRITED_EBOOK';
export const SET_VITURAL_KEYBOARD_VALUE = 'SET_VITURAL_KEYBOARD_VALUE';
export const SET_QUESTION_DATA_4_CHECK_ANSWER = 'SET_QUESTION_DATA_4_CHECK_ANSWER';
export const SET_QUESTION_LIST_4_CHECK_ANSWER = 'SET_QUESTION_LIST_4_CHECK_ANSWER';
export const SET_TXT_SELECTED_INPUT = 'SET_TXT_SELECTED_INPUT';